<template>
  <div class="page">
    <!-- 出签回寄 -->
    <div class="box-card">
      <div class="box-header">
        <span class="h4">出签回寄</span>
        <span>出签后护照、签证页等资料将会回寄至该地址</span>

      </div>
      <!-- 加一条线 -->
      <div class="line"></div>
      <div class="box-content" style="display: flex;flex-wrap: wrap;">
        <div :class="backaddress.Id == item.Id ? 'active' : ''" class="grid" v-for="(item , index) in addressList"
          :key="index" @click="selectAddress(item)">
          <p>收货人:{{item.Name}}</p>
          <p>电话：{{item.Phone}}</p>
          <p>地址:{{item.Province}}{{item.City}}{{item.Area}}{{item.Detail}}</p>
        </div>
        <div class="grid plus" @click="addAddress">
          + 添加收件地址
        </div>
      </div>
    </div>
    <!-- 新增地址弹框 -->
    <el-dialog class="payDialog" width="500px" top="25vh" title="新增收件地址" :visible.sync="showAddress">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="收货人">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="省市区">
          <el-cascader size="large" style="width:380px" filterable clearable :options="options"
            v-model="selectedOptions" @change="handleChange">
          </el-cascader>
        </el-form-item>

        <el-form-item label="详细地址">
          <el-input v-model="form.Detail"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 出行信息 -->
    <div class="box-card">
      <div class="box-header" style="display: flex;justify-content: space-between">
        <span class="h4">出行信息</span>
        <div><span>预计出行日期:</span><span style="color: #0092cc">{{travel_date}}</span></div>
      </div>
      <!-- 加一条线 -->
      <div class="line"></div>
      <div class="box-content">
        <div class="country">
          <img :src="orderInfo.NationalFlag" alt="" style="width: 30px; height: 20px; margin-right: 5px;">
          <span>{{orderInfo.VisaTitle}}</span>
        </div>
        <div class="personlist">
          <div class="person" v-for="(item, index) in applians" :key="index">
            <div class="name">{{item.PassengerName}}</div>
            <div class="type">{{item.PeopleType}}</div>
            <el-link type="primary" :href="item.Url" target="_blank">查看资料></el-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系人 -->
    <div class="box-card">
      <div class="box-header">
        <span class="h4">订单联系人</span>
        <span>审核资料时，如需补交或修改资料时将联系此号码</span>
      </div>
      <!-- 加一条线 -->
      <div class="line"></div>
      <div class="box-content">
        <div class="form-content">
          <el-input v-model="contacttName" placeholder="请输入联系人姓名">
            <el-input style="border: ;none" slot="prepend" v-model="phone" placeholder="请输入联系人电话"></el-input>
          </el-input>

          <el-input style="margin-left: 20px" v-model="mark" placeholder="如有特殊需求请留言"></el-input>
        </div>

      </div>
    </div>

    <!-- 顺丰上门取件 -->
    <div class="box-card" v-if="orderInfo.HasSF>0">
      <div class="box-header">

        <el-checkbox v-model="checked"><span class="h4">顺丰上门取件</span></el-checkbox>
        <span>若需邮寄资料未备齐，可在订单支付后再选择顺丰上门;20点后顺丰下单可能会第二天上门取件，请知悉</span>

      </div>
      <div class="line"></div>
      <div class="box-content" style="display: flex;flex-wrap: wrap;" v-if="checked">
        <p>资料将被送到以下地址{{orderInfo.MailInfo}} <el-button type="primary" @click="callexpress">呼叫快递</el-button>
        </p>
        <div :class="getaddress.Id == item.Id ? 'active' : ''" class="grid" v-for="(item , index) in addressList"
          :key="index" @click="selectSendAddress(item)">
          <p>收货人:{{item.Name}}</p>
          <p>电话：{{item.Phone}}</p>
          <p>地址:{{item.Province}}{{item.City}}{{item.Area}}{{item.Detail}}</p>
        </div>
        <div class="grid plus" @click="addAddress">
          + 添加收件地址
        </div>

      </div>
    </div>

    <div class="box-card" v-if="coupons.length>0">
      <div class="box-header">
        <el-checkbox v-model="usecoupons" @change="PlaceOrder()"></el-checkbox>
        <span>使用优惠券</span>
        <span>¥{{usecoupons?couponActive.money:0}}</span>
      </div>
      <!-- 加一条线 -->
      <div class="line"></div>
      <div class="box-content">
        <div v-if="usecoupons" class="coupon">
          <div v-for="item in coupons" :key="item.id" class="coupon-item" @click="useCoupon(item)"
            :class="item.id == couponActive.id ? 'active' : ''">
            <div class="coupon-left">

              <span>¥{{item.money}}</span>
            </div>
            <div class="coupon-right">
              <p class="text_a">{{item.title}}</p>

              <p class="text_b">{{item.takeeffectTime}}至{{item.invalidTime}}</p>
              <p class="text_c">{{item.mark}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="box-card">
      <div class="box-content-pay">
        <div class="content-left">
          <div class="content-left-item">
            当前余额¥{{balance}}


            <el-checkbox v-model="usebalance"></el-checkbox>
            <span>使用余额支付</span>
            <el-link type="primary" @click="dialogvisible = true">充值送券></el-link>
          </div>
        </div>
        <div class="content-right">
          <div class="content-right-item">
            <div class="goodsprice"><span>商品金额</span><span>¥{{order.VisaFee}}</span></div>
            <div class="goodsprice" v-if="coupons.length>0 && usecoupons"><span>优惠金额</span><span
                class="text_a">¥-{{usecoupons?couponActive.money:0}}</span>
            </div>

            <el-button type="primary" @click="pay" v-loading="loading" :disabled="loading || order.FinishGetMoney >= order.GetMoney">
              前往支付￥{{usecoupons?
              ((order.GetMoney - order.FinishGetMoney) - (couponActive.money && couponActive.isUse==0 ? couponActive.money: 0)).toFixed(2):(order.GetMoney - order.FinishGetMoney).toFixed(2)
            }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <paydialog :paytypeVisible="paytypeVisible" :paytype="1" :cashAmount="cashAmount" :orderId="orderId"
      @onClosed="payClosed" @payBack="paycallback">
    </paydialog>
    <recharge :dialogVisible="dialogvisible" @chargeclose="dialogclose" @rechargeBack="rechargecallback">
    </recharge>

    <!-- <el-dialog class="payDialog" width="320px" top="25vh" title="选择支付方式" :visible.sync="paytypeVisible"
      @closed="payClosed" append-to-body>
      <div class="payBtn_box" v-if="payDisable == false">
        <div style="">
          <img src="../../assets/wechat.png" style="margin-right: 10px;width: 60px;height: 60px" alt=""
            @click="GetViasPay('W01', cashAmount)">
          <img src="../../assets/alipay.png" style="margin-right: 10px;width: 60px;height: 60px" alt=""
            @click="GetViasPay('A01', cashAmount)">
        </div>

        <br />
        <p>请选择您的支付方式</p>
      </div>
      <div class="QrCode_box" v-if="payDisable == true">
        <div id="qrcode2" class="qrcode" ref="qrCodeUrl" v-loading="qrcodeLiading"></div>
        <p>{{ payPrompt }}</p>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import paydialog from "../../components/paydialog/paydialog.vue";
  import recharge from '../../components/Recharge/recharge.vue'
  import {
    regionData,
    codeToText
  } from 'element-china-area-data'
  export default {
    components: {
      paydialog,
      recharge
    },
    data() {
      return {
        options: regionData,
        orderDetail: {},
        orderId: this.$route.query.orderId,
        orderInfo: {},
        docList: [],
        applians: [],
        backaddress: {},
        getaddress: {},
        myAddress: {},
        status: '',
        isCustomH5: false,
        contacttName: '',
        phone: '',
        radio: '1',
        usecoupons: false,
        coupons: [],
        mark: '',
        couponActive: [],
        travel_date: '',
        order: {},
        paytypeVisible: false,
        payPrompt: '',
        payDisable: false,
        cashAmount: 0,
        qrcodeLiading: false,
        isQuery: false,
        timer: null,
        qrcodeobj: null,
        addressList: [],
        checked: false,
        form: {
          name: '',
          phone: '',
          Province: '',
          City: '',
          Area: '',
          Detail: '',
        },
        showAddress: false,
        selectedOptions: [],
        loading: false,
        balance: 0,
        usebalance: false,
        dialogvisible: false
      }
    },

    mounted() {
      this.GetOrderDetail();
      this.GetAddressList();
      this.GetUserBalance();
    },
    methods: {
      dialogclose() {
        this.dialogvisible = false
      },
      payClosed() {
        this.paytypeVisible = false;
        this.cashAmount = 0;
      },
      handleChange() {
        this.form.Province = ''
        this.form.City = ''
        this.form.Area = ''
        for (let i = 0; i < this.selectedOptions.length; i++) {
          if (i === 0) {
            this.form.Province = codeToText[this.selectedOptions[i]]
          }
          if (i === 1) {
            this.form.City = codeToText[this.selectedOptions[i]]
          }
          if (i === 2) {
            this.form.Area = codeToText[this.selectedOptions[i]]
          }
        }
      },
      selectAddress(item) {
        this.backaddress = item;
      },
      selectSendAddress(item) {
        this.getaddress = item;
        this.PlaceOrder();
      },
      GetOrderDetail() {
        this.loading = true
        var param = {
          orderId: this.orderId
        }
        this.$api.GetOrderDetail(param).then(res => {
            console.log('%corderpay.vue line:42 orderDetail', 'color: #007acc;', res.data);

            if (res.data.status == 200) {
              let activeCoupon = {}
              if (res.data.data.currentCoupon.length > 0) {
                activeCoupon = res.data.data.currentCoupon[0]
                console.log('进入1')
              } else if (res.data.data.coupons) {
                activeCoupon = res.data.data.coupons[0]
                console.log('进入2')
              }


              this.orderDetail = res.data.data
              this.applians = res.data.data.applians
              this.travel_date = res.data.data.applians.length > 0 ? res.data.data.applians[0].PlanStartTime : ''
              this.backaddress = res.data.data.backaddress || {}
              this.getaddress = res.data.data.getaddress || {}
              this.myAddress = res.data.data.myAddress || {}
              this.orderInfo = res.data.data.orderInfo || {}
              this.order = res.data.data.order
              this.docList = res.data.data.docList || []
              this.coupons = res.data.data.coupons || []
              this.mark = res.data.data.mark
              this.couponActive = activeCoupon || []
              this.radio = res.data.data.getaddress ? '2' : '1'
              this.status = res.data.data.status
              this.isCustomH5 = res.data.data.applians[0].Url.indexOf('/allstate') > -1
              this.contacttName = res.data.data.contactName
              this.phone = res.data.data.phone
              this.usecoupons = this.couponActive ? true : false
              this.loading = false
            } else {
              this.$message({
                message: "订单或程序有误！",
                type: 'error'
              })
            }
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
            console.log('%cerror orderpay.vue line:58 ', 'color: red; display: block; width: 100%;', err);
          })
      },
      callexpress() {
        var param = {
          orderId: this.orderId
        }
        this.$api.callexpress(param).then(res => {
          console.log('%corderpay.vue line:224 express', 'color: #007acc;', res);
          if (res.data.status == 200) {
            this.$message({
              message: "呼叫顺丰成功",
              type: 'success'
            })
          }
        })
      },
      GetUserBalance() {
        this.$api.GetUserBalance().then(res => {
          if (res.data.status == 200) {
            this.balance = res.data.data.Balance
          }
        })
      },
      GetAddressList() {
        this.$api.GetAddressList().then(res => {
          console.log('%corderpay.vue line:234 addressList', 'color: #007acc;', res);
          this.addressList = res.data.data

        }).catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
      },
      addAddress() {
        this.showAddress = true
      },
      onSubmit() {
        this.$api.AddAddress({
          Name: this.form.name,
          Phone: this.form.phone,
          Province: this.form.Province,
          City: this.form.City,
          Area: this.form.Area,
          Detail: this.form.Detail,
          Id: 0,
          IsDefault: 0
        }).then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.showAddress = false;
            this.GetAddressList();
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
            this.showAddress = false
          }
        })
        this.showAddress = false
      },

      useCoupon(item) {
        this.couponActive = item
        this.PlaceOrder()
      },
      PlaceOrder() {
        this.loading = true
        var param = {
          backAddressId: this.backaddress.Id,
          getAddressId: this.checked ? this.getaddress.Id : null,
          hasSF: this.checked ? 1 : 0,
          contactName: this.contacttName,
          // couponId: (this.usecoupons ? this.couponActive.id : null),
          couponId: null,
          departureTime: this.travel_date,
          // hasSF: 0,
          mark: this.mark,
          orderId: this.orderId,
          phone: this.phone,
        }
        this.$api.PlaceOrder(param).then(res => {
          console.log(res)
          if (res.data.status == 200) {
            // this.$message({
            //   message: "保存成功",
            //   type: 'success'
            // })
            this.loading = false
            // console.log('%corderpay.vue line:207 object', 'color: #007acc;', res.data);
            // this.$router.push({

            // })
            // this.GetOrderDetail();


          } else {
            return false
          }
        }).catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
          return false;
        })
      },
      rechargecallback() {
        this.dialogvisible = false
        this.GetUserBalance();
      },
      paycallback() {
        this.$router.push({
          path: '/orderlist'
        })
      },
      pay() {
        var that = this
        var param = {
          backAddressId: this.backaddress.Id,
          getAddressId: this.checked ? this.getaddress.Id : null,
          hasSF: this.checked ? 1 : 0,
          contactName: this.contacttName,
          couponId: (this.usecoupons ? this.couponActive.id : null),
          departureTime: this.travel_date,
          // hasSF: 0,
          mark: this.mark,
          orderId: this.orderId,
          phone: this.phone,
        }
        this.$api.PlaceOrder(param).then(res => {
          // console.log(res)
          if (res.data.status == 200) {
            // this.$message({
            //   message: res.data.message,
            //   type: 'success'
            // })
            // this.GetOrderDetail();
            if (!this.usebalance) {
              this.$nextTick(() => {
                // debugger
                this.paytypeVisible = true;
                this.cashAmount = this.usecoupons?
                    ((this.order.GetMoney - this.order.FinishGetMoney) - (this.couponActive.money && this.couponActive.isUse==0 ? this.couponActive.money: 0)).toFixed(2):
                    (this.order.GetMoney - this.order.FinishGetMoney).toFixed(2);
                // console.log('%corderpay.vue line:207 object', 'color: #007acc;', res.data);
              })

            } else {
              //使用余额支付
              var bAmount= this.usecoupons?
                    ((this.order.GetMoney - this.order.FinishGetMoney) - (this.couponActive.money && this.couponActive.isUse==0 ? this.couponActive.money: 0)).toFixed(2):
                    (this.order.GetMoney - this.order.FinishGetMoney).toFixed(2);
              this.$confirm('您本次将支付' + bAmount + '元, 是否继续?',
                '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(() => {
                this.loading = true
                that.$api.BalancePayment({
                  couponId: (this.usecoupons ? this.couponActive.id : null),
                  orderId: this.orderId
                }).then(res => {
                  console.log(res)
                  if (res.data.status == 200) {
                    this.loading = false
                    this.$message({
                      message: res.data.message,
                      type: 'success'
                    })
                    this.$router.push({
                      path: '/orderlist'
                    })
                  }
                  else {
                    this.loading = false
                    this.$message({
                      message: res.data.message,
                      type: 'error'
                    })
                  }
                }).catch(err => {
                  this.loading = false
                  this.$message({
                    message: err.message,
                    type: 'error'
                  })
                })
              })
            }


            // this.$router.push({

            // })
            // this.GetOrderDetail();


          } else {
            return false
          }
        }).catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
          return false;
        })

      },
    },

  }

</script>

<style lang="less" scoped>
  .page {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    /deep/ .el-input-group__prepend {
      background-color: #fff;
      width: 30%;
      padding: 0px 0px !important;
      border: none
    }

    .box-card {
      text-align: left;
      width: 860px;
      margin: 20px auto;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;

      .line {
        width: 100%;
        height: 1px;
        background-color: #eee;
        margin-bottom: 20px;
      }

      .box-header {
        margin-bottom: 20px;
        margin-right: 10px;
        display: inline-block;

        .h4 {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin: 0;
          margin-bottom: 10px;
        }

        span {
          font-size: 14px;
          color: #999;
          margin: 0;
          margin-bottom: 10px;
        }
      }

      .box-content {
        margin-bottom: 20px;

        .active {
          background-color: #42b0ff1f;
          box-shadow: 2px 2px 2px #42b0ff1f;
        }

        .plus {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .grid {
          width: 228px;
          height: 109px;
          border: 1px dashed #40b0ff;
          margin: 10px;
          padding: 10px;
          overflow: hidden;
          position: relative;

          p {
            margin: 0;
          }

          .tool {
            width: 250px;
            height: 20px;
            padding: 5px;
            font-size: 12px;
            position: absolute;
            top: 130px;
            background-color: #fff;

            span {
              cursor: pointer;
              display: block;
              float: right;
              color: #aaa;
              padding: 2px;
              margin: 0px 5px;
              background-color: #fff;
              border: 1px solid #ddd;
              border-radius: 8%;
            }
          }


        }

        .country {
          margin-bottom: 20px;
        }

        .personlist {
          .person {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            background-color: #f5f5f5;
            padding: 0 40px;
            height: 40px;
            line-height: 40px;
          }

        }

        .form-content {
          display: block;
          display: flex;
        }

        .coupon {
          display: flex;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          margin-bottom: 10px;
          flex-wrap: wrap;
          justify-content: flex-start;

          .coupon-item {
            height: 93px;
            border: 1px solid #333;
            border-radius: 4px;
            margin: 10px 10px;
            background:
              url('https://vias2019.oss-cn-shenzhen.aliyuncs.com/browser-upload-file/a5b7c280-0926-4d93-acc0-aee4f6c939de.png');
            background-size: cover;
            display: flex;
            width: 300px;

            .coupon-left {
              width: 30%;
              line-height: 93px;
              color: #fff;
              font-size: 28px;
              text-align: center;

              span {
                font-size: 24rpx
              }
            }

            .coupon-right {
              flex: 1;
              padding: 0px 20px;

              .text_a {
                font-size: 20px;
                color: #636363;
                line-height: 10px;
                margin: 20px 0px;
              }

              .text_b,
              .text_c {
                font-size: 12px;
                color: #acacac;
                line-height: 5px;
                margin: 10px 0px;
              }

              .text_c {
                line-height: 16px;
                border-top: 1px solid #434343;
                line-height: 20px;
              }
            }
          }

          .active {
            border: 2px solid #ff6223;
            box-shadow: 1px 1px 10px #ff6223;
          }

        }
      }

      .box-content-pay {
        height: 150px;
        display: flex;
        justify-content: space-around;

        .content-left {
          width: 60%;
        }

        .content-right {
          width: 40%;
          margin: 0px auto;
          padding: 20px 0 0 20px;

          .goodsprice {
            color: #999;
            font-size: 16px;
            margin-bottom: 10px;

            .text_a {
              font-size: 16px;
              color: #ff6223;
              line-height: 16px;
              font-weight: bold
            }
          }
        }
      }
    }

    .payBtn_box {
      text-align: center;
      margin-top: 20px;
    }


  }

  .qrcode {
    width: 124px;
    margin: 0px auto;
  }

</style>



// WEBPACK FOOTER //
// src/page/product/orderpay.vue